import { LockClockIcon } from './LockClockIcon';

/**
 * author: Google
 * id C16C2563-9EA4-4545-9CF4-56C5EA9FD9F9
 * name lock-clock
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-clock.svg
 * tags
 * - Lock 
 * - Date / Time 
 */
export const EncryptionExpirationIcon = LockClockIcon;
export default EncryptionExpirationIcon